<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :width="width" :height="height"
       viewBox="0 0 188 188">
    <defs>
      <linearGradient id="linear-gradient" x1="0.852" y1="0.143" x2="0.104" y2="0.832"
                      gradientUnits="objectBoundingBox">
        <stop offset="0" stop-color="#e21851"/>
        <stop offset="1" stop-color="#0f4cf3"/>
      </linearGradient>
    </defs>
    <g id="Group_2435" data-name="Group 2435" transform="translate(164 -3013)">
      <circle id="Ellipse_102" data-name="Ellipse 102" cx="94" cy="94" r="94" transform="translate(-164 3013)"
              fill="url(#linear-gradient)"/>
      <path id="telegram"
            d="M40.106,58.138,38.416,81.919c2.419,0,3.467-1.039,4.723-2.287L54.48,68.793,77.981,86c4.31,2.4,7.347,1.137,8.509-3.965L101.915,9.757l0,0c1.367-6.371-2.3-8.863-6.5-7.3L4.745,37.167c-6.188,2.4-6.094,5.852-1.052,7.415l23.181,7.21L80.719,18.1c2.534-1.678,4.838-.75,2.943.928Z"
            transform="translate(-128.105 3064.553)" fill="#f8f8f8"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: "ITelegram",
  props: {
    width: {
      type: String,
      default: '1.5em'
    },
    height: {
      type: String,
      default: '1.5em'
    }
  }
}
</script>

<style scoped>

</style>
